import React from "react";
import { AuthenticationManager, ResourceID } from "../../../common/AuthenticationManager";
import { Link } from "react-router-dom";
import { StringHelper } from "../../../common/Helpers";
import { BaseListing } from "../../common/BaseListing";
import { formatMovieVoucherCategoryName } from "../common/WebsiteManagementConstants";
import {
  NavigationItem,
  NavigationSettings,
} from "../../common/NavigationSettings";

export class VoucherTypeListing extends BaseListing {
  getApiPath = () => "/api/v1/voucher_types";

  getDefaultSort = () => "-UpdatedOn";

  getNavigationSettings = () => {
    return new NavigationSettings({
      parentModule: new NavigationItem({
        identifier: "website_managements",
        name: "Website Management",
      }),
      activeModule: new NavigationItem({
        identifier: "movie_vouchers",
        name: "Movie Vouchers",
      }),
    });
  };

  onRowClick = (id) => {
    this.props.history.push(`/movie_vouchers/${id}`);
  };

  generateTableContent() {
    return (
      <React.Fragment>
        <thead>
          <tr>
            <th>Name</th>
            <th>Category</th>
            <th>Display Start</th>
            <th>Display End</th>
            <th>
              Display Weight{" "}
              <i
                className="sort-button fas fa-sort-alpha-down"
                id="WeightDisplay"
                onClick={this.toggleSort}
              />
            </th>
            <th>
              Updated On{" "}
              <i
                className="sort-button fas fa-sort-alpha-down"
                id="UpdatedOn"
                onClick={this.toggleSort}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {this.state.data
            ? this.state.data.map((item, index) => {
              return (
                <tr key={index} onClick={() => this.onRowClick(item.id)}>
                  <td>{item.name}</td>
                  <td>{formatMovieVoucherCategoryName(item.category)}</td>
                  <td>
                    {StringHelper.asDateStringToDisplayDateTimeFormat(
                      item.displayStartTime
                    )}
                  </td>
                  <td>
                    {StringHelper.asDateStringToDisplayDateTimeFormat(
                      item.displayEndTime
                    )}
                  </td>
                  <td>{item.weightDisplay}</td>
                  <td>
                    {StringHelper.asDateStringToDisplayDateTimeFormat(
                      item.updatedOn
                    )}
                  </td>
                </tr>
              );
            })
            : null}
        </tbody>
      </React.Fragment>
    );
  }

  generateExtendedComponents() {
    return (
      <div className="d-flex flex-column flex-md-row justify-content-end mb-3">
        {AuthenticationManager.isAuthorized(
          ResourceID.MovieVoucherCreateButtonPage
        ) && (
            <Link
              className="btn btn-primary ml-2 mb-1"
              to="/movie_vouchers/create"
              style={{ fontSize: "1rem" }}
            >
              <i className="fa fa-plus-circle"></i> Create Movie Voucher
            </Link>)
        }
        <Link
          className="btn btn-primary ml-2 mb-1"
          to="/movie_vouchers/schedules"
          style={{ fontSize: "1rem" }}
        >
          Scheduled Publishing
        </Link>
      </div>
    );
  }
}
